import React, { useCallback, useEffect, useState } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import useStyles from './HeaderActions.styles';
import { Button, TextButton } from '../../../../common/components/buttons';
import { MissionExact } from '../../../models/Mission';
import useAgent from '../../../../common/hooks/useAgent';
import missionAgent from '../../../agents/missionAgent';
import { downloadFile } from '../../../../common/utils/fileMethods';
import Tooltip from '../../../../common/components/Tooltip';
import { Icon } from '../../../../common/components/icons';

const HeaderActions = ({ mission, onBackClick }) => {
  const classes = useStyles();

  const [downloadObstacles, setDownloadObstacles] = useState(true);

  const { isSubmitting, dirty } = useFormikContext();

  const [downloadMission, downloadedMission, isDownloadingMission] = useAgent(missionAgent.downloadMission);

  const handleDownloadJson = useCallback(() => downloadMission(mission.id, downloadObstacles), [downloadMission, downloadObstacles, mission.id]);

  useEffect(() => {
    if (!isDownloadingMission && downloadedMission && mission) {
      downloadFile(downloadedMission, mission.name, 'json', () => null);
    }
  }, [downloadedMission, isDownloadingMission, mission]);

  const handleCheckboxChange = () => {
    setDownloadObstacles(!downloadObstacles);
  };

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        {mission && mission.id && (
          <div>
            <FormControlLabel
              className={classes.checkbox}
              control={<Checkbox name="removeObstaclesFromMissionProfile" onChange={handleCheckboxChange} checked={!downloadObstacles} />}
              label={i18n.t('mission.removeObstacles')}
            />
            <Tooltip title={i18n.t('common.userInterface.unsavedModifications')} placement="top" hidden={!dirty}>
              <TextButton id="downloadButton" onClick={handleDownloadJson} disabled={dirty}>
                <Icon icon="download_for_offline" className={classes.textButtonIcon} />
                {i18n.t('mission.button.downloadMissionProfile')}
              </TextButton>
            </Tooltip>
          </div>
        )}

        <div>
          <Button className={classes.backToListButton} id="backButton" onClick={onBackClick}>
            {i18n.t('mission.button.backToList')}
          </Button>

          <Tooltip title={i18n.t('common.userInterface.noModificationsToSave')} placement="top" hidden={!mission.id || dirty}>
            <Button id="saveButton" type="submit" primary disabled={isSubmitting || (mission.id && !dirty)}>
              {i18n.t('common.button.save')}
            </Button>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

HeaderActions.propTypes = {
  mission: MissionExact,
  onBackClick: PropTypes.func,
};

HeaderActions.defaultProps = {
  mission: undefined,
  onBackClick: undefined,
};

export default HeaderActions;
